import { App } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_API_BASEURL || 'http://localhost:4000/graphql'
})

const TOKEN_KEY = 'okaso/token_key'

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem(TOKEN_KEY)
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    }
  }
})

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  // connectToDevTools: true,
})

export default {
  install: (app: App<any>) => {
    app.provide(DefaultApolloClient, apolloClient)
  }
}
